/**
 * Merkzettel über Dateien, die sich beim Bauen des Arbeitsdokuments nicht
 * lesen ließen.
 *
 * Ob eine Datei taugt, stellt sich erst beim Öffnen heraus – vorher ist eine
 * Datei ohne Endung schlicht unbekannt und wird deshalb versuchsweise als PDF
 * und als Bild gelesen. Scheitert beides, steht sie hier, und die
 * Materialliste kann sie rot markieren, statt jeden Verdachtsfall gleich als
 * kaputt auszuweisen.
 *
 * Bewusst nur im Browser gespeichert: es ist eine Anzeigehilfe, keine
 * Eigenschaft der Datei.
 */

const KEY = (topicId: string) => `doc_bad_${topicId}`;

export function readBadMaterials(topicId: string): Set<string> {
  try {
    return new Set(JSON.parse(localStorage.getItem(KEY(topicId)) ?? "[]") as string[]);
  } catch {
    return new Set();
  }
}

export function writeBadMaterials(topicId: string, ids: readonly string[]): void {
  try {
    if (ids.length) localStorage.setItem(KEY(topicId), JSON.stringify([...ids]));
    else localStorage.removeItem(KEY(topicId));
  } catch {
    /* ignore */
  }
}
